import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { Entity } from '../../types/entity';
import { useUpdateEntities } from '../../queries/use-update-entities';

type EntitiesArchiveConfirmProps = {
    entities: Entity[];
    isOpen: boolean;
    onClose: () => void;
    onArchive: () => void;
};

function EntitiesArchiveConfirm({ entities, isOpen, onClose, onArchive }: EntitiesArchiveConfirmProps): JSX.Element {
    const archiveEntitiesQuery = useUpdateEntities();

    function archiveQuery(): void {
        archiveEntitiesQuery.mutate(
            entities.map((e) => ({
                id: e.id,
                fields: { isArchived: true },
            })),
            {
                onSuccess: () => {
                    onArchive();
                    toastNotification('success', `${entities.length} ${entities.length === 1 ? 'entity' : 'entities'} archived!`);
                },
            }
        );
    }

    return (
        <Dialog
            title={`Archive ${entities.length === 1 ? 'Entity' : 'Entities'}`}
            description={`Do you want to archive ${
                entities.length > 1 ? `${entities.length} entities` : 'this entity'
            }? Any active integrations will be disconnected. Archived entities can be unarchived.`}
            isOpen={isOpen}
            primaryAction="Archive"
            secondaryAction="Cancel"
            type="error"
            onClose={onClose}
            onPrimaryActionClick={archiveQuery}
            onSecondaryActionClick={onClose}
            isLoading={archiveEntitiesQuery.isLoading}
        />
    );
}
export default EntitiesArchiveConfirm;
